export default "__VITE_ASSET__DPqAzOqI__"